// BMS: Collection of misc. inline scripts collected into a single deferred script file

//Lazy-loading function.

function loadFullsizeImages(){
  var all_small_images = document.querySelectorAll('img[data-fullsize-src]');
  for(var img=0; img<all_small_images.length; img++){
    var image = all_small_images[img];
    image.setAttribute('src', image.getAttribute('data-fullsize-src'));
    image.removeAttribute('data-fullsize-src');
  }
}

loadFullsizeImages();

$(document).on('click', '#add_to_order_modal', function (e) {
  $(this).removeClass('force-visible').addClass('force-hidden');
});

$(document).on('click', '.modal-dialog', function (e) {
  e.stopPropagation();
});

$(document).on('click', '.modal-header button, #add_to_order_modal .close_modal_btn', function () {
  $('#add_to_order_modal').removeClass('force-visible').addClass('force-hidden');
});

$(document).on('click', '.add_modal_btn', function () {
  $('#add_to_order_modal').addClass('force-visible').removeClass('force-hidden');
});

if (window.Template === 'index') {
  $('.heroSlider').slick({
    arrows: false,
    dots: true
  });
}

//Template-specific js
if (window.resetPassword){
  $(function() {
    timber.resetPasswordSuccess();
  });
}



  jQuery(function($) {
    ajaxCart.init({
      formSelector: '#AddToCartForm',
      cartContainer: '#CartContainer',
      addToCartSelector: '#AddToCart',
      cartCountSelector: '#CartCount',
      cartCostSelector: '#CartCost',
      moneyFormat: window.money_format
    });
  });

  jQuery('body').on('ajaxCart.afterCartLoad', function(evt, cart) {
    // Bind to 'ajaxCart.afterCartLoad' to run any javascript after the cart has loaded in the DOM
    timber.RightDrawer.open();
  });


